import { CURRENT_SERVICE_TYPE, SERVICE_TYPE } from '@utility/checkout-utils';

export const itIt = {
  ACCESS_DENIED: 'Accesso negato.',
  ACCOUNT_SELECTION_VIEW_TITLE: 'Selezione conto',
  APPROVE_YOUR_PAYMENT_IN_APP: 'Si prega di approvare $t(SUBJECT_DEFINITE)',
  AUTHENTICATION_METHOD: 'Metodo di autenticazione',
  AUTHENTICATION_METHOD_VIEW_TITLE: 'Metodo di autenticazione',
  AWAITING_DECOUPLED_AUTHORISATION_VIEW_TITLE: "In attesa dell'autorizzazione",
  CANCEL_PAYMENT: 'Cancella $t(SUBJECT_DEFINITE)',
  CHIP_TAN_HEADER: 'chipTAN',
  CHIP_TAN_SUBHEADER: 'Utilizzi il suo dispositivo generatore di chipTAN',
  CLOSE_CANCEL_MODAL: 'Chiudi la finestra per cancellare $t(SUBJECT_DEFINITE)',
  CODE_IS_NOT_WORKING: 'Il codice non funziona',
  CONFLICT: 'Conflitto.',
  CONTINUE: 'Continua',
  CONTINUE_TO_YOUR_BANK: 'Continua nella tua banca',
  HIDE_PASSWORD: 'Nascondi password / PIN',
  I_DID_NOT_RECEIVE_CODE: 'Non ho ricevuto il codice',
  I_DO_NOT_HAVE_MY_DEVICE: 'Non ho il mio dispositivo a portata di mano',
  I_DO_NOT_REMEMBER_MY_BANK_CREDENTIALS:
    'Non ricordo le credenziali di accesso alla mia banca',
  I_WANT_TO_PAY_ANOTHER_WAY: 'Voglio pagare in un altro modo',
  INTERNAL_SERVER_ERROR:
    'Qualcosa è andato storto. Si prega di contattare il supporto.',
  LOADING_BANK_INFORMATION: 'Caricamento informazioni bancarie',
  LOG_IN: 'Accesso',
  LOGIN_VIEW: 'Schermata di accesso',
  LOGIN_VIEW_TITLE: 'Accesso',
  M_TAN_HEADER: 'mTAN',
  M_TAN_SUBHEADER: 'Il suo TAN le verrà inviato via SMS',
  MASKED_IBAN_ACCESSIBLE:
    'IBAN mascherato che inizia con {{prefix}} e termina con {{suffix}}.',
  MY_AUTHENTICATION_METHOD_IS_NOT_DISPLAYED:
    'Il mio metodo di autenticazione non è presente',
  MY_BANK_ACCOUNT_IS_NOT_DISPLAYED: 'Il mio conto bancario non è visualizzato',
  NETWORK_ERROR: 'Errore di connessione. Controlla la connessione e riprova.',
  OOPS_IT_APPEARS_THERE_IS_AN_ISSUE:
    'Ops, sembra ci sia stato un problema. Si prega di ricaricare la pagina.',
  OPEN_CANCEL_MODAL: 'Apri la finestra per cancellare $t(SUBJECT_DEFINITE)',
  OTHER: 'Altro',
  PAGE_LOADING: 'Caricamento della pagina - attendere prego.',
  PASSWORD: 'Password',
  PAYING_WITH: 'Pagando con',
  PHOTO_OTP_CHALLENGE_IMAGE_DESCRIPTION:
    'Immagine del codice Photo OTP (One Time Password)',
  PHOTO_OTP_FALLBACK_IMAGE_DESCRIPTION:
    'Non siamo riusciti a mostrare il tuo codice immagine. Aggiorna la pagina o cancella $t(SUBJECT_DEFINITE).',
  PHOTO_TAN_HEADER: 'photoTAN',
  PHOTO_TAN_SUBHEADER: "Scansioni una grafica a colori con un'app o un lettore",
  PLEASE_USE_SAME_LOGIN_DETAILS:
    "Si prega di usare le stesse credenziali di accesso che verrebbero usate nell'applicazione o sul sito della banca.",
  PROVIDE_VALID_LOGIN_DETAILS_TO_CONTINUE:
    'Fornisci credenziali di accesso valide per continuare',
  PROVIDE_VALID_VERIFICATION_CODE_TO_CONTINUE:
    'Fornisci un codice valido per continuare',
  PUSH_TAN_HEADER: 'pushTAN',
  PUSH_TAN_SUBHEADER: "Autenticazione tramite un'app sicura",
  REDIRECT_OTP_HEADER: 'Redirect',
  REDIRECT_OTP_SUBHEADER:
    'Verrai reindirizzato a una pagina sicura per ottenere il tuo codice monouso.',
  REDIRECT_VIEW_TITLE: 'Reindirizzamento in corso',
  RESOURCE_NOT_FOUND: 'Risorsa non trovata.',
  RESOURCE_NOT_MODIFIABLE:
    'Le credenziali di autenticazione fornite per un $t(SUBJECT_INDEFINITE) non incorporato.',
  RETRY_LIMIT_EXCEEDED:
    "Il limite di tentativi è stato raggiunto. L'autenticazione è fallita.",
  SCAN_CODE_WITH_YOUR_APP:
    "Scansiona l'immagine nell'app della tua banca e inserisci qui il codice.",
  SELECT_ACCOUNT: 'Seleziona il tuo account',
  SELECT_AUTHENTICATION_METHOD: 'Seleziona il metodo di autenticazione',
  SELECT_AUTHENTICATION_METHOD_DISABLED_REASON:
    'Seleziona il metodo di autenticazione per continuare',
  SELECTED_BANK_DETAILS: 'Dettagli della banca selezionata',
  SHOW_PASSWORD: 'Mostra password / PIN',
  SOMETHING_WENT_WRONG: 'Qualcosa è andato storto',
  SUBJECT_DEFINITE:
    CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS
      ? "l'accesso all'account"
      : 'il pagamento',
  SUBJECT_INDEFINITE:
    CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS
      ? "un accesso all'account"
      : 'un pagamento',
  SUBMIT_AND_CANCEL_PAYMENT: 'Invia e cancella $t(SUBJECT_DEFINITE)',
  SUBMITTING_CANCEL: 'Annullamento in corso - Attendi',
  SUBMITTING_LOGIN: 'Accesso in corso - Attendere prego.',
  SUBMITTING_VERIFICATION_CODE:
    'Invio del codice di autenticazione in corso - Attendere prego.',
  SUBMITTING_VERIFICATION_METHOD:
    'Invio del metodo di verifica in corso - Attendere prego.',
  TAP_THE_PUSH_NOTIFICATION_FROM: 'Dovrebbe ricevere una notifica push.',
  TO_IMPROVE_YOUR_NEXT_EXPERIENCE:
    'Al fine di migliorare il servizio, vorremmo capire perché vuole cancellare $t(SUBJECT_DEFINITE).',
  UNAUTHORISED_LOGIN:
    "Le informazioni di accesso all'istituzione fornite non sono valide.",
  UNAUTHORISED_VERIFICATION: 'Il codice di verifica specificato non è valido.',
  USER: 'Utente',
  VERIFICATION_CODE: 'Codice di verifica',
  VERIFICATION_VIEW_TITLE: 'Verifica',
  VERIFY: 'Verifica',
  VERIFY_PAYMENT: 'Verifica $t(SUBJECT_DEFINITE)',
  VOLT_SCA: 'Volt SCA',
  WAITING_FOR_VERIFICATION_VIEW_TITLE: 'In attesa della verifica',
  WAITING_FOR_VERIFY_STATUS:
    'In attesa dello stato di verifica e reindirizzamento',
  YOUR_CODE_IS_DISPLAYED_IN_PUSHTAN_APP:
    'Il suo codice è mostrato sulla sua app per PushTAN o in un SMS sul suo telefono.',
} as const;
